import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth.jsx";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login.jsx";
import Layout from "@/components/Layout.jsx";
import Dashboard from "@/pages/Dashboard.jsx";
import Settings from "@/pages/Settings.jsx";
import Knowledge from "@/pages/Knowledge.jsx";
import Connections from "@/pages/Connections.jsx";
import Schedules from "@/pages/Schedules.jsx";
import "@/App.css";

function Protected({ children }) {
  const { authed, loading } = useAuth();
  if (loading)
    return (
      <div className="h-screen flex items-center justify-center text-zinc-500 font-mono text-xs">
        Initializing DoppelGanger...
      </div>
    );
  if (!authed) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="settings" element={<Settings />} />
            <Route path="knowledge" element={<Knowledge />} />
            <Route path="schedules" element={<Schedules />} />
            <Route path="connections" element={<Connections />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
